module.exports = __webpack_public_path__ + "img/pic10.7ab6d886.png";